import { createAsyncThunk } from '@reduxjs/toolkit'

import axiosInstance from 'libraries/axios'
import { setCookie } from 'libraries/cookie'

export const signIn = createAsyncThunk('auth/signIn', async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance.get(`/v2/auth/register-guest`)

    setCookie('token', data.data.token)

    return data.data
  } catch (error: any) {
    return rejectWithValue(error.response.data)
  }
})
